import React from "react";

function Footer() {
  return (
    <footer className='w-full bg-background'>
      <div className='swiss-container'>
        <div className='grid grid-cols-1 gap-y-8 border-t border-line py-12 md:grid-cols-12 md:gap-x-10'>
          {/* Identity */}
          <div className='md:col-span-5'>
            <p className='font-heading text-2xl font-bold uppercase tracking-tight text-primary'>
              Zin Myo Win
            </p>
            <p className='mt-2 font-body text-sm text-primary/45'>
              Full-Stack Developer
            </p>
          </div>

          {/* Links */}
          <div className='md:col-span-4'>
            <p className='font-body text-2xs font-medium uppercase tracking-widest text-primary/40'>
              Elsewhere
            </p>
            <div className='mt-4 flex flex-col gap-2'>
              <a
                href='https://github.com/ZinMyoWin'
                target='_blank'
                rel='noopener noreferrer'
                className='font-body text-sm text-primary/70 transition-colors hover:text-accent'
              >
                GitHub
              </a>
              <a
                href='https://www.linkedin.com/in/zin-myo-win/'
                target='_blank'
                rel='noopener noreferrer'
                className='font-body text-sm text-primary/70 transition-colors hover:text-accent'
              >
                LinkedIn
              </a>
              <a
                href='mailto:zinmyowin0567@gmail.com'
                className='font-body text-sm text-primary/70 transition-colors hover:text-accent'
              >
                Email
              </a>
            </div>
          </div>
        </div>

        <div className='flex flex-col gap-2 border-t border-line py-6 sm:flex-row sm:items-center sm:justify-between'>
          <span className='font-body text-2xs uppercase tracking-widest text-primary/35'>
            © 2026 Zin Myo Win. All rights reserved.
          </span>
          <span className='font-body text-2xs uppercase tracking-widest text-primary/35'>
            Portfolio 2026
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
